export var millisPerDay = 24 * 3600 * 1000;
export var dayBoundary = "00:00:00.000";
export var SOD = 'SOD';
export var EOD = 'EOD';